/**
 * "Beauty Pros You Can Trust" — a 50/50 split section shown on every service detail page:
 * a blue panel (heading, subtitle, three icon + copy rows) on the left and a lifestyle
 * photo on the right. Styled to match the Figma "Why Glamsquad" design (node 1491:4723).
 */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { mq } from '../../helpers'

const ROWS = [
  { icon: '/service-detail/why-licensed.svg', text: 'All pros are fully licensed and background-checked before a single booking' },
  { icon: '/service-detail/why-matched.svg', text: 'Get matched with a top-tier pro or rebook your favorite' },
  { icon: '/service-detail/why-schedule.svg', text: 'Choose your service, date, and time. We handle the rest' },
]

const BeautyProsYouCanTrust = () => (
  <Wrapper>
    <div className="panel">
      <div className="content">
        <h2>Beauty Pros You Can Trust</h2>
        <p className="sub">
          With 1,700+ vetted beauty pros across 18 US cities, your best hair day is always on your
          schedule — not the salon&apos;s.
        </p>
        <ul>
          {ROWS.map(row => (
            <li key={row.text}>
              <img src={row.icon} alt="" aria-hidden="true" width={48} height={48} />
              <span>{row.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="image">
      <Image
        src="/service-detail/why-glamsquad.jpg"
        alt="A GLAMSQUAD beauty pro styling a smiling client at home"
        fill
        sizes="(max-width: 900px) 100vw, 50vw"
        style={{ objectFit: 'cover' }}
      />
    </div>
  </Wrapper>
)

const Wrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: stretch;

  ${mq('max', '900px')} {
    grid-template-columns: minmax(0, 1fr);
  }

  .panel {
    background: ${c.cobalt};
    display: flex;
    align-items: center;
    padding: 80px 88px;
    ${mq('max', '900px')} {
      padding: 48px 24px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  h2 {
    font-family: Garnett;
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    color: ${c.white};
    margin: 0 0 16px;
    ${mq('max', '900px')} {
      font-size: 24px;
      line-height: 30px;
    }
  }

  .sub {
    font-family: Euclid;
    font-size: 22px;
    line-height: 1.45;
    color: ${c.white};
    margin: 0 0 40px;
    ${mq('max', '900px')} {
      font-size: 18px;
      margin-bottom: 32px;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  li {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  li img {
    flex-shrink: 0;
  }

  li span {
    font-family: Euclid;
    font-size: 18px;
    line-height: 1.45;
    color: ${c.white};
    ${mq('max', '900px')} {
      font-size: 16px;
    }
  }

  .image {
    position: relative;
    background: #c8c8cc;
    min-height: 668px;
    ${mq('max', '900px')} {
      order: -1;
      min-height: 0;
      aspect-ratio: 4 / 3;
    }
  }
`

export default BeautyProsYouCanTrust
